// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"70e322a4","217":"8af853c5","331":"d13341ed","453":"c25f43ab","483":"168bbd08","518":"c38c6834","526":"d16d1fb8","604":"1d0b1012","881":"16f7ba1f"}[chunkId] + ".chunk.js";
};